import { fetchData } from './../_helpers/fetchData';
var data = function (endpoint, id) {
    return fetchData(endpoint + "/" + id).then(function (response) { return ({ response: response }); }, function (error) { return ({ error: error }); });
};
export var leaseService = {
    data: data,
};
